<script>
import { get } from 'lodash';

export default {
  name: 'Breadcrumbs',
  computed: {
    root () {
      return this.$router.options.routes.filter(route => route.path === '/').pop();
    },
    routes() {
      const flatten = routes => {
        return routes.children.reduce((accumulated, current) => {
          if (current.name && current.meta && current.meta.breadcrumb) {
            accumulated[current.name] = { ...current.meta.breadcrumb, name: current.name };
          }

          if (current.children) {
            accumulated = Object.assign({}, accumulated, flatten(current));
          }

          return accumulated;
        }, {});
      };

      return flatten(this.root);
    },
    title () {
      return this.$route.meta && this.$route.meta.breadcrumb ? this.$route.meta.breadcrumb.label : 'Dashboard';
    },
    breadcrumbs () {
      const breadcrumb = this.$route.meta.breadcrumb;

      if (!breadcrumb || !breadcrumb.parent) {
        return null;
      }

      const provideBreadcrumbs = (current, breadcrumbs = []) => {
        breadcrumbs.push(current);
        const parent = get(this, `routes.${current.parent}`);
        if (parent) {
          parent.name = current.parent;
          provideBreadcrumbs(parent, breadcrumbs);
        }
        return breadcrumbs;
      };

      const breadcrumbs = provideBreadcrumbs(breadcrumb).reverse();
      breadcrumbs.pop();
      return breadcrumbs || null;
    },
    activeLabel () {
      return this.$route.meta && this.$route.meta.breadcrumb ? this.$route.meta.breadcrumb.label : '';
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
<template>
  <nav aria-label="breadcrumb" class="breadcrumb d-flex justify-content-between align-items-center rounded-0 m-0">
    <h3>{{ title }}</h3>
    <ol class="breadcrumb p-0 m-0 rounded-0" v-if="breadcrumbs">
      <li class="breadcrumb-item">
        <router-link :to="{ name: 'dashboard' }">Home</router-link>
      </li>
      <li class="breadcrumb-item" v-for="(breadcrumb, index) in breadcrumbs" :key="index">
        <router-link :to="{ name: breadcrumb.name }" v-if="breadcrumb.name">{{ breadcrumb.label }}</router-link>
        <router-link :to="breadcrumb.path" v-else>{{ breadcrumb.label }}</router-link>
      </li>
      <li class="breadcrumb-item active" aria-current="page">{{ activeLabel }}</li>
    </ol>
  </nav>
</template>
